// Template
//
// {
//   _name: 'descriptive name with environment',
//   id: '',
//   redirect: '',
//   secret: '',
// },

import { IS_STAGING } from '@/env';
import { generateWildcardRegexPattern } from '@/utils/generate-wildcard-regex-pattern';

export const applications = [
  // localhost
  {
    _name: 'localhost primary',
    id: '618ab8038deee8f4ab48e1ccc122e320',
    redirect: 'http://localhost:3000/authenticate',
    secret: '3ce345b71168a613540ed1e268bac402',
  },
  {
    _name: 'localhost next auth',
    id: '618ab8038deee8f4ab48e1ccc122e320',
    redirect: 'http://localhost:3000/api/auth/callback/yv',
    secret: '3ce345b71168a613540ed1e268bac402',
  },
  {
    _name: 'localhost secondary',
    id: 'd731cd8dd34e48ec30fd8a1ac1067e4d',
    redirect: 'http://localhost:3000/authenticate',
    secret: '43e911640cd7ba2574e18a52fcf5c962',
  },
  {
    _name: 'localhost login.youversion.com',
    id: '1aaba4d95b8f5100df0208e11006afbe',
    redirect: 'http://localhost:3000/authenticate',
    secret: 'd4be55f54a6e999f278fa4c6dc50d139',
  },
  // login.youversion.com
  {
    _name: 'login production',
    id: '85b61d97a79b96be465ebaeee83b1313',
    redirect: 'https://login.youversion.com/authenticate',
    secret: '75cf0e141cbf41ef410adce5b6537a49',
  },
  {
    _name: 'login staging',
    id: '1aaba4d95b8f5100df0208e11006afbe',
    redirect: 'https://login-staging.youversion.com/authenticate',
    secret: 'd4be55f54a6e999f278fa4c6dc50d139',
  },
  // connect.youversion.com
  {
    _name: 'youversion connect production',
    id: '63e04df02bcbda314fce9aed7a9d1051',
    redirect: 'https://connect.youversion.com/authenticate',
    secret: 'fb06517404b0218326573cedb5e3417c',
  },
  {
    _name: 'youversion connect staging',
    id: '119b484422a20e159f979a66c692fc93',
    redirect: 'https://connect-staging.youversion.com/authenticate',
    secret: '846527da845a5b90ee81fb64ccd09e90',
  },
  {
    _name: 'youversion connect review',
    id: 'beb45aab1afb5b4723cb02e70677e2b5',
    redirect: 'https://connect-review-*.youversion.com/authenticate',
    secret: 'ad0e771c8d0c9c36cc6db69f1176793e',
  },
  // support-portal.youversion.com
  {
    _name: 'support portal production',
    id: '04f81a75a367e5427a41766290982fb5',
    redirect: 'https://support-portal.youversion.com/authenticate',
    secret: '0e42dfdaba1e0faaab4314bdff21d11d',
  },
  {
    _name: 'support portal production (proxy)',
    id: '04f81a75a367e5427a41766290982fb5',
    redirect: 'https://ns-cf207dc3-443-lifechurch.npaproxy.goskope.com/authenticate',
    secret: '0e42dfdaba1e0faaab4314bdff21d11d',
  },
  {
    _name: 'support portal staging',
    id: 'ad99e5290f77d869a3ec7c9a7678a378',
    redirect: 'https://support-portal-staging.youversion.com/authenticate',
    secret: '33e23f5c27f66016f2fdbf97093ac952',
  },
  {
    _name: 'support portal review',
    id: 'b9f7f9023c3070e110997be5c9b562a5',
    redirect: 'https://support-portal-review-*.youversion.com/authenticate',
    secret: '865a83874444ef49e3a48038ffa22019',
  },
  // support-portal.youversion.church
  {
    _name: 'church support portal production',
    id: '04f81a75a367e5427a41766290982fb5',
    redirect: 'https://support-portal.youversion.church/authenticate',
    secret: '0e42dfdaba1e0faaab4314bdff21d11d',
  },
  {
    _name: 'church support portal staging',
    id: 'ad99e5290f77d869a3ec7c9a7678a378',
    redirect: 'https://support-portal-staging.youversion.church/authenticate',
    secret: '33e23f5c27f66016f2fdbf97093ac952',
  },
  {
    _name: 'church support portal review',
    id: 'b9f7f9023c3070e110997be5c9b562a5',
    redirect: 'https://support-portal-review-*.youversion.church/authenticate',
    secret: '865a83874444ef49e3a48038ffa22019',
  },
  // story-builder.youversion.com
  {
    _name: 'story builder production',
    id: '59a3e188d74090e9939774ad14e1a1a7',
    redirect: 'https://story-builder.youversion.com/authenticate',
    secret: 'eaceec402d9eb9dc98eb17947884c34f',
  },
  {
    _name: 'story builder staging',
    id: '8f3e682244129ba5c5ce35b998b26a26',
    redirect: 'https://story-builder-staging.youversion.com/authenticate',
    secret: '924dcfefc9d9e69c22811671c4bc73da',
  },
  {
    _name: 'story builder review',
    id: 'beb45aab1afb5b4723cb02e70677e2b5',
    redirect: 'https://*-story-builder.review.youversion.com/authenticate',
    secret: 'ad0e771c8d0c9c36cc6db69f1176793e',
  },
  // give.bible.com
  {
    _name: 'giving web production next auth',
    id: 'f02c41adf11c159fb36d62e987f76945',
    redirect: 'https://give.bible.com/api/auth/callback/yv',
    secret: '5d4b71920e35746eb6ac91622f710463',
  },
  {
    _name: 'giving web production',
    id: 'f02c41adf11c159fb36d62e987f76945',
    redirect: 'https://give.bible.com/authenticate',
    secret: '5d4b71920e35746eb6ac91622f710463',
  },
  {
    _name: 'giving web staging next auth',
    id: '0af47199aea51a74649245f7b9ad3ade',
    redirect: 'https://give-*.bible.com/api/auth/callback/yv',
    secret: '448c696d69931ca5a36754f0b759a4b9',
  },
  {
    _name: 'giving web staging',
    id: '0af47199aea51a74649245f7b9ad3ade',
    redirect: 'https://give-*.bible.com/authenticate',
    secret: '448c696d69931ca5a36754f0b759a4b9',
  },
  // bible.com
  {
    _name: 'bible.com',
    id: '96aa43c822350c765fd177f95ebc5575',
    redirect: 'https://bible.com/authenticate',
    secret: '74ddc9dc4788490a8b0ad3fe9f052d4e',
  },
  {
    _name: 'www.bible.com',
    id: '96aa43c822350c765fd177f95ebc5575',
    redirect: 'https://www.bible.com/authenticate',
    secret: '74ddc9dc4788490a8b0ad3fe9f052d4e',
  },
  {
    _name: 'bible.com staging',
    id: 'a99a574a14cff3523fb23cdcac72f980',
    redirect: 'https://staging.bible.com/authenticate',
    secret: 'f5365b4a7eb596bfff0746d74c11e99f',
  },
  {
    _name: 'bible.com review',
    id: 'c79ba5a44f7576225e4c44c0b2da0b1a',
    redirect: 'https://bible-review-*.bible.com/authenticate',
    secret: '499ab59939f3b60e51eade057aeff0ea',
  },
  /**
   * Example Apps.
   */
  // example-nextjs-app-router.thewardro.be
  {
    _name: 'example nextjs app router',
    id: 'bf1a8d748988e00035649af37e2b3549',
    redirect: 'https://example-nextjs-app-router.thewardro.be/authenticate',
    secret: '7daa4014a974bb201b1e0e83dec1be3e',
  },
  {
    _name: 'example nextjs app router - staging',
    id: '8a6ee793d700bb5eb6b125f4c602be93',
    redirect: 'https://example-nextjs-app-router-staging.thewardro.be/authenticate',
    secret: 'f50cc130a404e176b9973b261d107800',
  },
  {
    _name: 'example nextjs app router - review',
    id: '6ae43eaf31f0058ec27e18818ea4a261',
    redirect: 'https://review-*.example-nextjs-app-router.thewardro.be/authenticate',
    secret: '812ad16272e7875f93b57291420fbf53',
  },
  // example-nextjs-pages-router.thewardro.be
  {
    _name: 'example nextjs pages router',
    id: 'ba31d790540f2fe582f26e2d0d94d2be',
    redirect: 'https://example-nextjs-pages-router.thewardro.be/authenticate',
    secret: '34f8a45a8ffe94cf2c4161e88b625cf7',
  },
  {
    _name: 'example nextjs pages router - staging',
    id: 'a89989a798f84a5a0906329e7e7ff47e',
    redirect: 'https://example-nextjs-pages-router-staging.thewardro.be/authenticate',
    secret: '87e2edc3fb9fad03498d031f07326212',
  },
  {
    _name: 'example nextjs pages router - review',
    id: '06cea5eed334ab9bff91f7dbc4bb0e64',
    redirect: 'https://review-*.example-nextjs-pages-router.thewardro.be/authenticate',
    secret: 'f5716800757fc82654e09450b2d34256',
  },
  // Youversion Platform Staging
  {
    _name: 'yvp',
    id: '5d00f7937d507f61b8fcfc693c32095e',
    redirect: 'https://api-dev.youversion.com/auth/callback',
    secret: '311cbf75048acbd93fa01d3d543fa945',
  },
] as const;
// The application that this login app will redirect to if no other target is provided for redirection.
export const DEFAULT_TARGET_APPLICATION = applications.find(application =>
  IS_STAGING ? application._name === 'bible.com staging' : application._name === 'www.bible.com'
);

// These are used to allow `app-review-*` patterns through.
const validStagingUrls = [
  new URL('https://youversion.com/youversion/success'),
  new URL('https://youversion.com/authenticate'),
  new URL('https://youversion.church/authenticate'),
  new URL('https://www.bible.com/authenticate'),
  new URL('https://thewardro.be/authenticate'),
];

function decodeUri(uri: string): string {
  const decodedUri = decodeURIComponent(uri);
  return decodedUri.endsWith('/') ? decodedUri.slice(0, -1) : decodedUri;
}

export function isValidRedirectUri({ clientId, redirectUri }: { clientId: string; redirectUri: string }): boolean {
  const redirectUriPart = redirectUri.split('?')[0];
  const redirectURL = new URL(decodeUri(redirectUriPart));

  const matchedApplications = applications.filter(application => application.id === clientId);

  if (!matchedApplications.length) {
    return false;
  }

  if (matchedApplications.some(app => generateWildcardRegexPattern(app.redirect).test(redirectUriPart))) {
    return true;
  }

  // This logic was set in place before regex matching existed. It might be able to be removed if we have
  // the URLs setup correctly in the application object.
  return (
    IS_STAGING &&
    validStagingUrls.some(allowedUrl => {
      // Grab just the root domain of the redirect url. For staging/review we don't care about the other bits.
      const redirectDomain = redirectURL.host.split('.').slice(-2).join('.');
      return allowedUrl.host === redirectDomain && allowedUrl.pathname === redirectURL.pathname;
    })
  );
}

export function getClientSecret(clientId: string | undefined): string | undefined {
  const application = applications.find(app => app.id === clientId);
  return application?.secret;
}
